import Navbar from "../molecules/navbar/navbar";
import HeaderContent from "../molecules/header/header";
import Services from "../molecules/section-one/services";
import Processes from "../molecules/section-two/processes";
import WhoWeAre from "../molecules/section-three/who-we-are";
import Partners from "../molecules/section-four/partners";
import Schedule from "../molecules/section-five/schedule";
import Development from "../molecules/section-six/development";
import AdditionalServices from "../molecules/section-seven/additional-services.jsx";
import Industries from "../molecules/section-eight/industries";
import LearnServices from "../molecules/section-nine/learn-services"
import FreqAskedQuest from "../molecules/section-ten/freq-asked-quest"
import Footer from "../molecules/footer/footer"
import { useState, useEffect } from "react";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Link } from "react-scroll";

const MainPage = () => {
    const [visible, setVisible] = useState(false)
    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY)
        })

        if (scroll > 1233) {
            setVisible(true)
        }else {
            setVisible(false)
        }

    }, [scroll])

    return (
        <div className="app" id="top">
            <Navbar />
            <HeaderContent />
            <Services />
            <Processes />
            <WhoWeAre />
            <Partners />
            <Schedule />
            <Development />
            <AdditionalServices />
            <Industries />
            <LearnServices />
            <FreqAskedQuest />
            <Footer />
            <Link to="top" className={visible ? "visible-top active" : "visible-top"} spy={true} smooth={true} offset={-100} duration={1500}>
                <div className={visible ? "top active" : "top"}>
                    <ArrowUpwardIcon className="top-icon" />
                </div>
            </Link>
        </div>
    )
}

export default MainPage;